import React, { forwardRef, useState, useEffect } from "react";
import FetchData from "../../providers/dataProvider";
import Select from "react-select";
import { DropDownComponent } from "../../dropdown/DropDownComponent";
import { PlaceHolder } from "../../constants/PlaceHolderConstants";
import {
  compareDates,
  convertLocalToUTCDate,
  formatDate,
  getStorageData,
} from "../../utils/Validate";

const style = {
  control: (base) => ({
    ...base,
    boxShadow: "none",
    border: "1px solid #B4BABF",
    backgroundColor: "#F9FBFC",
    fontSize: "14px",
    minHeight: "35px",
    height: "35px",
    borderRadius: "6px",
    color: "#000000",
    whiteSpace: "nowrap",
  }),
};

const EnquiryFilter = (props) => {
  const {
    search,
    setDateRange,
    setStatus,
    projectData,
    setProjectData,
    projectName,
    customerName,
    distributorName,
    projectReference,
    assignedEngineerData,
    allocatedToName,
    setInquiryFilter,
    InquiryFilter,
    setProjectName,
    setCustomerName,
    DatePicker,
    dateRange,
    ClearFilter,
    ApplyFilter,
    setDistributorName,
    setProjectReference,
    setAllocatedToName,
    setAssignedEngineerData,
    customerInquiryData,
    ApplySearch,
    setTableData,
    menuRights,
  } = props;

  const [startDate, endDate] = dateRange;
  const [custList, setCustList] = useState([]);
  // datepicker start
  const ExampleCustomInput = forwardRef(({ value, onClick, onChange }, ref) => (
    <input
      value={value}
      className="example-custom-input form-control"
      onClick={onClick}
      onChange={onChange}
      ref={ref}
      placeholder="DD/MM/YYYY - DD/MM/YYYY"
    ></input>
  ));
  // datepicker end

  const { data: projectList } = FetchData("project");
  const { data: assignedEngineerList } = FetchData("userprofile");
  const { data: distributorList } = FetchData("distributor");
  const { data: customerList } = FetchData("Customer");
  const { data: countryList } = FetchData("country");

  const [projectRefData, setProjectRefData] = useState([]);
  const [distributorData, setDistributorData] = useState([]);

  const [inquiryTypes, setInquiryTypes] = useState([
    { value: "1", label: "Job In Hand" },
    { value: "2", label: "Tender" },
  ]);

  useEffect(() => {
    const getDistributorData = () => {
      if (distributorList) {
        const list = formatDistributorList(distributorList);
        setDistributorData(list);
      }
    };
    getDistributorData();
  }, [distributorList]);

  const formatDistributorList = (list) => {
    var te = list?.map((data, index) => ({
      label: data?.distributorName,
      value: data?.id,
    }));
    return te;
  };

  useEffect(() => {
    const getCustomerData = () => {
      if (customerList) {
        const list = formatCustomerRef(customerList);
        setCustList(list);
      }
    };
    getCustomerData();
  }, [customerList]);

  const formatCustomerRef = (list) => {
    var te = list?.map((data, index) => ({
      label: data?.customerName,
      value: data?.id,
    }));
    return te;
  };

  useEffect(() => {
    const getProjectData = () => {
      if (projectList) {
        const list = formatProjectList(projectList);
        const refList = formatProjectRef(projectList);
        setProjectData(list);
        setProjectRefData(refList);
      }
    };
    getProjectData();
  }, [projectList]);

  useEffect(() => {
    const getAssignedEngineerList = () => {
      if (assignedEngineerList) {
        const list = formatAssignedEngineerList(assignedEngineerList);
        setAssignedEngineerData(list);
      }
    };
    getAssignedEngineerList();
  }, [assignedEngineerList]);

  const formatAssignedEngineerList = (list) => {
    var te = list?.map((data, index) => ({
      label: data?.firstName + " " + data?.lastName,
      value: data?.identityId,
    }));
    return te;
  };

  const formatProjectList = (list) => {
    var te = list?.map((data, index) => ({
      ...data,
      label: data?.projectName,
      value: data?.id,
      ref: data?.projectCode,
    }));
    return te;
  };

  const formatProjectRef = (list) => {
    var te = list?.map((data, index) => ({
      label: data?.projectCode,
      value: data?.id,
    }));
    return te;
  };

  const handleFilterChange = (selectedOption, params) => {
    if (params === "projectname") {
      setProjectName(selectedOption);
      setInquiryFilter({
        ...InquiryFilter,
        projectName: selectedOption?.label,
      });
    }
    if (params === "customername") {
      setCustomerName(selectedOption);
      setInquiryFilter({
        ...InquiryFilter,
        customerName: selectedOption?.label,
      });
    }
    if (params === "distributorname") {
      setDistributorName(selectedOption);
      setInquiryFilter({
        ...InquiryFilter,
        distributorName: selectedOption?.label,
      });
    }
    if (params === "projectreference") {
      setProjectReference(selectedOption);
      setInquiryFilter({
        ...InquiryFilter,
        projectReference: selectedOption?.label,
      });
    }
    if (params === "assignedengineer") {
      setAllocatedToName(selectedOption);
      setInquiryFilter({
        ...InquiryFilter,
        allocatedToName: selectedOption?.label,
      });
    }
    if (params === "status") {
      setStatus(selectedOption);
      setInquiryFilter({
        ...InquiryFilter,
        status: selectedOption?.label,
      });
    }
    if (params === "createdDate") {
      setDateRange(selectedOption);
    }
  };

  useEffect(() => {
    let filterdata = customerInquiryData.map((filterItem, index) => {
      var countryValue = countryList.filter(function (item) {
        return item.id === filterItem.countryId;
      });
      const distObject = distributorData?.find(
        (item) => item?.value == filterItem?.distributorId
      );
      const engineerObject = assignedEngineerData?.find(
        (item) => item?.value == filterItem?.salesEngineerId
      );
      const customerObject = customerList?.find(
        (item) => item?.id == filterItem?.customerId
      );
      const projectObject = projectData?.find(
        (item) => item?.value == filterItem?.projectId
      );
      const enquiryObject = inquiryTypes?.find(
        (proj) => proj?.value == filterItem?.inquiryType
      );

      const crDate = new Date(filterItem?.createdAt);
      const formattedDate = `${crDate.getFullYear()}-${(crDate.getMonth() + 1)
        .toString()
        .padStart(2, "0")}-${crDate.getDate().toString().padStart(2, "0")}`;
      filterItem["createdDate"] = formattedDate;
      filterItem.countryName = countryValue[0]?.name;
      filterItem.allocatedToName = engineerObject?.label;
      filterItem.customerName = customerObject?.customerName;
      filterItem["projectName"] = projectObject?.label;
      filterItem["enquiryType"] = enquiryObject?.label;
      filterItem.dueDateEnq = formatDate(filterItem?.dueDate, "");
      filterItem.inqDate = formatDate(filterItem?.createdAt, "");
      filterItem["distributorName"] = distObject?.label;
      filterItem["projectReference"] = projectObject?.ref;
      filterItem.status = filterItem.isActive === true ? "Active" : "Inactive";
      filterItem["dateFilter"] = filterItem?.dueDate.split("T")[0];
      const dateRes = compareDates(
        filterItem?.dueDate.split("T")[0],
        new Date().toISOString().split("T")[0]
      );
      filterItem["dateClassName"] = dateRes ? "INACTIVE" : "ACTIVE";
      filterItem["view"] = menuRights?.canView === true ? "VIEW" : "NOT-VIEW";
      return filterItem;
    });
    filterdata = [...filterdata]?.sort(
      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    );
    if (search != "") ApplySearch();
    else setTableData(filterdata);
  }, [
    customerInquiryData,
    countryList,
    assignedEngineerData,
    customerList,
    projectData,
    distributorData,
  ]);
  return (
    <>
      <div
        className="modal fade drawer right-align"
        id="filterRightSideModalPopup"
        tabindex="-1"
        role="dialog"
        aria-labelledby="filterRightSideModalPopupLabel"
      >
        <div className="modal-dialog modal-sm" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <i className="fas fa-filter"></i>
              <h5 className="modal-title">Filters</h5>
              <i className="fas fa-times" data-dismiss="modal"></i>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <div className="mt-2">
                    <label>Project Name</label>
                    <DropDownComponent
                      placeHolder={PlaceHolder?.SELECT_PROJECT}
                      pageName="EnquiryList"
                      dpDownName="project"
                      stateData={projectList}
                      controlName="projectname"
                      handleChange={(e) => {
                        handleFilterChange(e, "projectname");
                      }}
                      valueId={InquiryFilter?.projectName}
                      value={projectName}
                      setState={setProjectName}
                      checkLabel={true}
                    />
                  </div>
                  <div className="mt-2">
                    <label>Customer Name</label>
                    <DropDownComponent
                      placeHolder={PlaceHolder?.SELECT_CUSTOMER}
                      pageName="EnquiryList"
                      dpDownName="customer"
                      stateData={customerList}
                      controlName="customername"
                      handleChange={(e) => {
                        handleFilterChange(e, "customername");
                      }}
                      valueId={InquiryFilter?.customerName}
                      value={customerName}
                      setState={setCustomerName}
                      checkLabel={true}
                    />
                  </div>
                 {getStorageData()?.userType!==2 && (<div className="mt-2">
                    <label>Distributor</label>
                    <DropDownComponent
                      placeHolder={PlaceHolder?.SELECT_DISTRIBUTOR}
                      pageName="EnquiryList"
                      dpDownName="distributor"
                      stateData={distributorList}
                      controlName="distributorname"
                      handleChange={(e) => {
                        handleFilterChange(e, "distributorname");
                      }}
                      valueId={InquiryFilter?.distributorName}
                      value={distributorName}
                      setState={setDistributorName}
                      checkLabel={true}
                    />
                  </div>)}
                  <div className="mt-2">
                    <label>Project Reference</label>
                    <DropDownComponent
                      placeHolder={PlaceHolder?.SELECT_PROJECT}
                      pageName="EnquiryList"
                      dpDownName="projectreference"
                      stateData={projectRefData}
                      controlName="projectreference"
                      handleChange={(e) => {
                        handleFilterChange(e, "projectreference");
                      }}
                      valueId={InquiryFilter?.projectReference}
                      value={projectReference}
                      setState={setProjectReference}
                      checkLabel={true}
                    />
                  </div>
                  <div className="mt-2">
                    <label>Assigned Engineer</label>
                    <DropDownComponent
                      placeHolder={PlaceHolder?.SELECT_ASSIGNED}
                      pageName="DistributorList"
                      dpDownName="salesengineer"
                      stateData={assignedEngineerList}
                      controlName="assignedengineer"
                      handleChange={(e) => {
                        handleFilterChange(e, "assignedengineer");
                      }}
                      valueId={InquiryFilter?.allocatedToName}
                      value={allocatedToName}
                      setState={setAllocatedToName}
                      checkLabel={true}
                    />
                  </div>
                  <div className="mt-2">
                    <label>Duration</label>
                    <DatePicker
                      name="duration"
                      selectsRange={true}
                      startDate={startDate}
                      endDate={endDate}
                      onChange={(e) => handleFilterChange(e, "createdDate")}
                      customInput={<ExampleCustomInput />}
                      dayClassName={() => "example-datepicker-day-class"}
                      popperClassName="example-datepicker-class"
                      dateFormat="dd/MM/yyyy"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="footer-modal">
              <div className="row">
                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <div className="d-flex justify-content-between">
                    <button
                      type="button"
                      className="btn clear-all-btn"
                      data-dismiss="modal"
                      onClick={ClearFilter}
                    >
                      Clear all
                    </button>
                    <button
                      type="button"
                      className="btn apply-btn"
                      data-dismiss="modal"
                      onClick={ApplyFilter}
                      disabled={dateRange[0] != null && dateRange[1] == null}
                    >
                      Apply
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EnquiryFilter;
